const StatusMessage = ({ type = 'success', message, onDismiss }) => {
  if (!message) {
    return null;
  }

  const styles =
    type === 'success'
      ? 'border-green-200 bg-green-50 text-green-800'
      : 'border-red-200 bg-red-50 text-red-700';

  return (
    <div
      role="status"
      className={`flex items-start justify-between gap-4 rounded-md border px-4 py-3 text-sm ${styles}`}
    >
      <p>{message}</p>
      {onDismiss ? (
        <button
          type="button"
          onClick={onDismiss}
          className="!bg-transparent !p-0 text-[12px] font-medium !text-inherit !shadow-none hover:!bg-transparent hover:!shadow-none"
        >
          Dismiss
        </button>
      ) : null}
    </div>
  );
};

export default StatusMessage;
